export const appData = {
	data: null,
	setData (data) {
		this.data = data;
	},
	getData () {
		return this.data;
	}
};
